import ButtonController from "../../../components/containers/buttonController";
import Pagination from '../../../components/common/pagination/Pagination';
import InfoToolTip from "../../../components/common/tooltip/InfoToolTip";
import { reportConfig } from '../../../utils/config/tableReportConfig';
import DynamicTable from '../../../components/tables/dynamicTable';
import { config as customConfig } from "../../../config/Constants";
import { getFilteredReport } from "../../../utils/api/reportData";
import { getDynamicSelectData } from '../../../utils/api/data';
import CircularProgress from '@mui/material/CircularProgress';
import Sidebar from '../../../components/sidebar/Sidebar';
import NavBar from '../../../components/navbar/NavBar';
import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import './tablereport.css';
import Axios from 'axios';

const TableReport = () => {
  const pageSize = 250;
  const totalPages = 100;
  const [reportData, setReportData] = useState([]);
  const [reportInfo, setReportInfo] = useState({});
  const location = useLocation();
  const [rowsDisplayed, setRowsDisplayed] = useState(0);
  const { reportName, reportId } = location.state || {};
  const config = reportConfig[reportName?.toLowerCase()];

  const reportFilters = useSelector((state) => state.report.reportFilter);

  useEffect(() => {
    const isDefaultFilter = reportFilters.length === 1 &&
      reportFilters[0].field === '' &&
      reportFilters[0].operator === '' &&
      reportFilters[0].value === '';

    if (!isDefaultFilter) {
      getFilteredData();
    }
  }, [reportFilters])

  const getReportData = async() => {
    if (Cookies.get('cp-role') !== '13') {
      const response = await getDynamicSelectData({
        selectValues: config.selectValues,
        tableName: config.tableName,
        whereField: config.whereField,
        whereOperators: config.whereOperators,
        whereValue: config.getWhereValue(),
        orderBy: config.orderBy,
        offset: { rowsDisplayed: rowsDisplayed, pageSize: pageSize },
        db: config.db,  
      });
      setReportData({data: response});
    }
    if (Cookies.get('cp-role') == '13') {
      const response = await Axios.get(customConfig.url.GET_REPORT, {
      params: {
        reportName: reportName,
        companyName: Cookies.get("cp-cn"),
      },
    });
      setReportData({data: response.data.report})
    };
  };

  const getReportInfo = async() => {
    const response = await getDynamicSelectData({
      selectValues: 'TOP 1 TIME_RANGE, REPORT_DESCRIPTION',
      tableName: 'REPORTS.REPORT_INFO',
      whereField: ["FK_REPORT_ID"],
      whereOperators: ["="],
      whereValue: [reportId],
      orderBy: "TIME_RANGE DESC",
      db: 'SQL SERVER',  
    });
    setReportInfo(response[0]);
  }

  const getDownloadData = async() => {
    if (Cookies.get('cp-role') !== '13') {
      const key = (reportConfig[reportName?.toLowerCase()]?.getDownloadData || reportName).toLowerCase();
      const localConfig = reportConfig[key];

      const response = await getDynamicSelectData({
        selectValues: localConfig.selectValues,
        tableName: localConfig.tableName,
        whereField: localConfig.whereField,
        whereOperators: localConfig.whereOperators,
        whereValue: localConfig.getWhereValue(),
        orderBy: localConfig.orderBy,
        db: localConfig.db,
      });
      return response;
    }
    if (Cookies.get('cp-role') == '13') {
      const response = await Axios.get(customConfig.url.GET_REPORT, {
      params: {
        reportName: reportName,
        companyName: Cookies.get("cp-cn"),
      },
    });
        return response.data.report
    };
  }

  const getFilteredData = async() => {
    const filteredData = await getFilteredReport(reportName, Cookies.get('cp-cn'), reportFilters);
    setReportData({data: filteredData})
  }

  useEffect(() => { getReportData(); getReportInfo(); }, []);
  useEffect(() => {  getReportData() }, [ rowsDisplayed])

  const handlePageChange = (event, newPage) => {
    setRowsDisplayed((newPage - 1) * pageSize);
  };
    
  return (
    <div className='costTrendsPage'>
    <div className="LandingPageContainer">
      <NavBar />
      <Sidebar />
      <div className="tableReportsPageContent">
        <div className="tableReportTop">
          <div className="scoreBoardTitle">
            <h1>{reportName}</h1>
          </div>
          {reportInfo && <InfoToolTip info={reportInfo} />}
        </div>
        <div className="tableReportsMid">
          <div className="tableReportsSpace">
            <div className="report">
              {reportData.length === 0  ? (
                <div className="tableReportLoader">
                  <CircularProgress />
                </div>
              ) : (
                <>
                  <DynamicTable dataObject={reportData} />
                  <div className="tabledReportdownloadButton">
                    <div className="tabledReportLeft">
                      <Pagination totalPages={totalPages} onPageChange={handlePageChange} boundaryCount={2} />
                    </div>
                    <div className="tabledReportRight">
                      <ButtonController reportName={reportName} onDownloadClick={getDownloadData}/>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}

export default TableReport